import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";
import { BrandingProvider } from "@/context/BrandingContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { MarketingLayout } from "@/components/MarketingLayout";
import { AppLayout } from "@/components/AppLayout";
import { AdminLayout } from "@/components/AdminLayout";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Features from "@/pages/Features";
import Compare from "@/pages/Compare";
import Pricing from "@/pages/Pricing";
import Security from "@/pages/Security";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import VerifyEmail from "@/pages/VerifyEmail";
import ResetPassword from "@/pages/ResetPassword";
import ForgotPassword from "@/pages/ForgotPassword";
import CheckEmail from "@/pages/CheckEmail";
import Terms from "@/pages/Terms";
import CookiePolicy from "@/pages/CookiePolicy";
import { CookieConsent } from "@/components/CookieConsent";
import { SeoManager } from "@/components/SeoManager";
import { SubscriptionExpired } from "@/components/SubscriptionExpired";
import DashboardHome from "@/pages/DashboardHome";
import GovernanceRules from "@/pages/GovernanceRules";
import Connections from "@/pages/Connections";
import ConnectionDetail from "@/pages/ConnectionDetail";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import Extraction from "@/pages/Extraction";
import AttachmentMigration from "@/pages/AttachmentMigration";
import Campaigns from "@/pages/Campaigns";
import Team from "@/pages/Team";
import Billing from "@/pages/Billing";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminAudit from "@/pages/admin/AdminAudit";
import AdminDeleted from "@/pages/admin/AdminDeleted";
import AdminBilling from "@/pages/admin/AdminBilling";
import AdminInvoices from "@/pages/admin/AdminInvoices";
import AdminPromos from "@/pages/admin/AdminPromos";
import AdminEmieQuality from "@/pages/admin/AdminEmieQuality";
import AdminSalesforce from "@/pages/admin/AdminSalesforce";
import AdminInstance from "@/pages/admin/AdminInstance";
import AdminDeployments from "@/pages/admin/AdminDeployments";
import DeployGuide from "@/pages/DeployGuide";
import NotFound from "@/pages/NotFound";

function AppRoutes() {
  return (
    <Routes>
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/security" element={<Security />} />
        <Route path="/deploy" element={<DeployGuide />} />
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/check-email" element={<CheckEmail />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardHome />} />
        <Route path="connections" element={<Connections />} />
        <Route path="connections/:system" element={<ConnectionDetail />} />
        <Route path="jobs" element={<Jobs />} />
        <Route path="jobs/:id" element={<JobDetail />} />
        <Route path="extraction" element={<Extraction />} />
        <Route path="attachments" element={<AttachmentMigration />} />
        <Route path="governance" element={<GovernanceRules />} />
        <Route path="campaigns" element={<Campaigns />} />
        <Route path="team" element={<Team />} />
        <Route path="billing" element={<Billing />} />
      </Route>
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminOverview />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="audit" element={<AdminAudit />} />
        <Route path="deleted" element={<AdminDeleted />} />
        <Route path="billing" element={<AdminBilling />} />
        <Route path="invoices" element={<AdminInvoices />} />
        <Route path="promos" element={<AdminPromos />} />
        <Route path="emie" element={<AdminEmieQuality />} />
        <Route path="salesforce" element={<AdminSalesforce />} />
        <Route path="instance" element={<AdminInstance />} />
        <Route path="deployments" element={<AdminDeployments />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrandingProvider>
          <AuthProvider>
            <BrowserRouter>
              <SeoManager />
              <AppRoutes />
              <CookieConsent />
              <SubscriptionExpired />
            </BrowserRouter>
            <Toaster position="top-center" />
          </AuthProvider>
        </BrandingProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
